import { withStyles, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// Over-write Table Cell styles
export const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#132a47',
    color: '#FFFFFF',
    fontWeight: 'bold',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

// Over-write Table Row styles
export const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// Adhoc over-write styles for components
export const UseStyles = makeStyles((theme) => ({
  skeletonLoading: {
    marginTop: '48px',
  },
  table: {
    minWidth: 650,
  },
  button: {
    marginBottom: '16px',
    marginTop: '16px',
  },
  downloadCSVLink: {
    textDecoration: 'none',
  },
  root: {
    "& .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-columnHeaderTitle": {
      overflow: "visible",
      lineHeight: "0.9rem",
      whiteSpace: "normal",
    },
    '& > *': {
      margin: theme.spacing(1),
    },
    '& .MuiDataGrid-columnsContainer': {
      backgroundColor: '#132a47',
      color: '#FFFFFF',
      fontWeight: 'bold',
    },
  },
}));
